"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoutubeIcon = exports.TwitterIcon = exports.TargetedMarket = exports.Shield = exports.Schedule = exports.QuestionMark = exports.PinterestIcon = exports.InstagramIcon = exports.Income = exports.Heart = exports.Growth = exports.Filter = exports.FacebookIcon = exports.Diversified = exports.CloseButton = exports.CRE = exports.ArrowDark = exports.Arrow = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index.styled"));

var _excluded = ["fill", "title"],
    _excluded2 = ["fill", "title"],
    _excluded3 = ["fill", "fillBackground", "title"],
    _excluded4 = ["fill", "title"],
    _excluded5 = ["fill", "title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CloseButton = function CloseButton(props, _ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Close Button' : _ref$title,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000' : _ref$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.0469 8L14.875 3.21875L15.8594 2.23438C16 2.09375 16 1.85938 15.8594 1.67188L14.8281 0.640625C14.6406 0.5 14.4062 0.5 14.2656 0.640625L8.5 6.45312L2.6875 0.640625C2.54688 0.5 2.3125 0.5 2.125 0.640625L1.09375 1.67188C0.953125 1.85938 0.953125 2.09375 1.09375 2.23438L6.90625 8L1.09375 13.8125C0.953125 13.9531 0.953125 14.1875 1.09375 14.375L2.125 15.4062C2.3125 15.5469 2.54688 15.5469 2.6875 15.4062L8.5 9.59375L13.2812 14.4219L14.2656 15.4062C14.4062 15.5469 14.6406 15.5469 14.8281 15.4062L15.8594 14.375C16 14.1875 16 13.9531 15.8594 13.8125L10.0469 8Z"
  }));
};

exports.CloseButton = CloseButton;

var Arrow = function Arrow(props, _ref2) {
  var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? 'Arrow' : _ref2$title,
      _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? '#000' : _ref2$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 24,
    height: "42",
    viewBox: "0 0 24 42",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.3125 41.625L22.9688 40.9688C23.4375 40.5 23.4375 39.8438 22.9688 39.375L4.6875 21L22.9688 2.71875C23.4375 2.25 23.4375 1.59375 22.9688 1.125L22.3125 0.46875C21.8438 0 21.1875 0 20.7188 0.46875L0.9375 20.25C0.46875 20.7188 0.46875 21.375 0.9375 21.8438L20.7188 41.625C21.1875 42.0938 21.8438 42.0938 22.3125 41.625Z"
  }));
};

exports.Arrow = Arrow;

var ArrowDark = function ArrowDark(props, _ref3) {
  var _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? 'Arrow Dark' : _ref3$title,
      _ref3$fill = _ref3.fill,
      fill = _ref3$fill === void 0 ? '#000' : _ref3$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 24,
    height: "42",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.41,15.41,12,10.83l4.59,4.58L18,14,12,8,6,14Z"
  }));
};

exports.ArrowDark = ArrowDark;

var CRE = function CRE(props, _ref4) {
  var _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? 'CRE' : _ref4$title,
      _ref4$fill = _ref4.fill,
      fill = _ref4$fill === void 0 ? '#000' : _ref4$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 73,
    height: props.height || 73,
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "desktop/icon/large/knowledge",
    stroke: "none",
    strokeWidth: "1",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1-Copy",
    transform: "translate(8.000000, 4.000000)",
    stroke: "#000000",
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.501,30.883 L36.501,4.75 L57.285,4.75 L57.285,60.75 L37.75,60.75 L37.75,30.883 L36.501,30.883 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "Stroke-4",
    points: "0.75 60.75 37.75 60.75 37.75 30.883 0.75 30.883"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "Stroke-4",
    transform: "translate(8.937500, 29.209750) scale(1, -1) translate(-8.937500, -29.209750) ",
    points: "5 30.4195 12.875 30.4195 12.875 28 5 28"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    id: "Stroke-4-Copy",
    transform: "translate(20.937500, 29.209750) scale(1, -1) translate(-20.937500, -29.209750) ",
    points: "17 30.4195 24.875 30.4195 24.875 28 17 28"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.2854,12.8066 L47.2854,18.8066",
    id: "Stroke-6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.2854,24.4355 L47.2854,30.4355",
    id: "Stroke-7"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.2854,36.0645 L47.2854,42.0645",
    id: "Stroke-8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47,56.8066 L47,60",
    id: "Stroke-9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40,0.8066 L40,4",
    id: "Stroke-9-Copy"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44,0.8066 L44,4",
    id: "Stroke-9-Copy-2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.8582,36.75 L29.6422,36.75",
    id: "Stroke-10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.8582,42.75 L29.6422,42.75",
    id: "Stroke-11"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.8582,48.75 L29.6422,48.75",
    id: "Stroke-12"
  }))));
};

exports.CRE = CRE;

var Diversified = function Diversified(props, _ref5) {
  var _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? 'Diversified' : _ref5$title,
      _ref5$fill = _ref5.fill,
      fill = _ref5$fill === void 0 ? '#000' : _ref5$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    width: "62",
    height: "59",
    viewBox: "0 0 62 59",
    title: title,
    fill: props.fill || fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.0819 23.827L60.0276 24.6231L60.8512 24.5627L60.7781 23.6447L60.0819 23.827ZM50.5561 24.5261L49.8665 24.7661L49.9558 25.3623L50.5018 25.3222L50.5561 24.5261ZM49.7942 21.4485L49.1398 21.8316L49.7942 21.4485ZM26.9275 11.0195L26.2731 11.4026L26.4603 11.9362L26.991 11.7958L26.9275 11.0195ZM24.101 2.96358L24.0079 2.19584L23.1384 2.4682L23.4466 3.34668L24.101 2.96358ZM58.7805 17.6459L59.4349 17.2628L58.7805 17.6459ZM61.1471 31.7186L61.834 31.7541L61.9784 30.8655L61.2015 30.9224L61.1471 31.7186ZM43.7264 55.1232L43.0722 55.5066L43.3093 56.1816L43.9486 55.8362L43.7264 55.1232ZM40.9558 47.2362L40.7039 46.5402L40.058 46.9265L40.3015 47.6196L40.9558 47.2362ZM51.8847 32.3973L51.9391 31.6012L51.3439 31.6448L51.205 32.3233L51.8847 32.3973ZM19.3294 3.64119L19.9838 3.25811L19.7467 2.58226L19.1068 2.92845L19.3294 3.64119ZM22.1159 11.5841L22.3682 12.2799L23.0133 11.8936L22.7703 11.201L22.1159 11.5841ZM10.8869 32.4681L11.0446 33.212L11.6703 32.9472L11.5786 32.2437L10.8869 32.4681ZM1.92272 36.2614L1.23946 36.538L1.3889 37.298L2.08043 37.0054L1.92272 36.2614ZM38.6889 55.9476L38.782 56.7153L39.6514 56.443L39.3433 55.5646L38.6889 55.9476ZM5.4604 43.8687L5.30265 43.1248L4.43498 43.492L4.83653 44.3255L5.4604 43.8687ZM14.3916 40.0887L14.9994 39.6006L14.7419 39.1297L14.2338 39.3447L14.3916 40.0887ZM35.8991 47.9941L36.5535 47.611L36.3663 47.0774L35.8356 47.2178L35.8991 47.9941ZM60.1362 23.0308L50.6104 23.7299L50.5018 25.3222L60.0276 24.6231L60.1362 23.0308ZM51.2456 24.286C51.0824 23.1959 50.8182 22.1189 50.4486 21.0654L49.1398 21.8316C49.478 22.7955 49.7183 23.7767 49.8665 24.7661L51.2456 24.286ZM50.4486 21.0654C47.2194 11.8619 37.0672 7.54428 26.864 10.2432L26.991 11.7958C36.7252 9.22087 46.1829 13.4041 49.1398 21.8316L50.4486 21.0654ZM27.5819 10.6364L24.7553 2.58048L23.4466 3.34668L26.2731 11.4026L27.5819 10.6364ZM24.194 3.73132C38.9181 -0.880411 53.6243 5.19822 58.1261 18.029L59.4349 17.2628C54.6521 3.63099 39.2182 -2.56818 24.0079 2.19584L24.194 3.73132ZM58.1261 18.029C58.8119 19.9834 59.2248 21.9888 59.3857 24.0093L60.7781 23.6447C60.6058 21.4814 60.1642 19.3412 59.4349 17.2628L58.1261 18.029ZM60.4603 31.6831C58.9991 40.6721 52.8017 49.3866 43.5043 54.4103L43.9486 55.8362C53.6412 50.599 60.2635 41.4157 61.834 31.7541L60.4603 31.6831ZM44.3807 54.7399L41.6101 46.8529L40.3015 47.6196L43.0722 55.5066L44.3807 54.7399ZM41.2077 47.9323C47.1638 44.3702 51.3077 38.6108 52.5645 32.4713L51.205 32.3233C50.0711 37.8624 46.2994 43.1938 40.7039 46.5402L41.2077 47.9323ZM51.8304 33.1935L61.0928 32.5147L61.2015 30.9224L51.9391 31.6012L51.8304 33.1935ZM18.675 4.02426L21.4615 11.9672L22.7703 11.201L19.9838 3.25811L18.675 4.02426ZM21.8636 10.8883C13.8714 15.6744 9.11758 24.4199 10.1951 32.6924L11.5786 32.2437C10.6128 24.8287 14.8514 16.7813 22.3682 12.2799L21.8636 10.8883ZM10.7292 31.7241L1.76502 35.5175L2.08043 37.0054L11.0446 33.212L10.7292 31.7241ZM2.60599 35.9848C0.28743 24.1936 7.1927 11.0408 19.5519 4.35393L19.1068 2.92845C6.23376 9.89334 -1.26209 23.8162 1.23946 36.538L2.60599 35.9848ZM38.5958 55.1799C25.0025 59.4382 11.4059 54.4582 6.08427 43.4119L4.83653 44.3255C10.4766 56.0326 24.7165 61.1216 38.782 56.7153L38.5958 55.1799ZM5.61815 44.6126L14.5493 40.8326L14.2338 39.3447L5.30265 43.1248L5.61815 44.6126ZM13.7838 40.5767C17.8018 47.926 26.8498 51.1813 35.9626 48.7703L35.8356 47.2178C27.168 49.5109 18.6996 46.3686 14.9994 39.6006L13.7838 40.5767ZM35.2447 48.3771L38.0345 56.3306L39.3433 55.5646L36.5535 47.611L35.2447 48.3771Z"
  }));
};

exports.Diversified = Diversified;

var Filter = function Filter(props, _ref6) {
  var _ref6$title = _ref6.title,
      title = _ref6$title === void 0 ? 'Filter' : _ref6$title,
      _ref6$fill = _ref6.fill,
      fill = _ref6$fill === void 0 ? '#000' : _ref6$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 24,
    height: "42",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.764,21.676a.986.986,0,0,1-.985-.986v-.986H2.956a.985.985,0,1,1,0-1.97H14.78v-.985a.985.985,0,0,1,1.97,0v3.942A.987.987,0,0,1,15.764,21.676Zm4.927-1.971H17.735v-1.97h2.956a.985.985,0,1,1,0,1.97ZM6.898,14.78a.987.987,0,0,1-.986-.986v-.985H2.956a.985.985,0,0,1,0-1.97H5.912V9.853a.985.985,0,0,1,1.97,0v3.941A.986.986,0,0,1,6.898,14.78Zm13.793-1.971H8.871v-1.97h11.82a.985.985,0,0,1,0,1.97ZM12.809,7.882a.987.987,0,0,1-.986-.986V5.912H2.956a.986.986,0,0,1,0-1.971h8.867V2.956a.986.986,0,0,1,1.971,0V6.897A.987.987,0,0,1,12.809,7.882Zm7.882-1.97H14.78V3.942h5.911a.986.986,0,1,1,.06279,1.971q-.03138.001-.06279,0Z"
  }));
};

exports.Filter = Filter;

var Heart = function Heart(props, _ref7) {
  var _ref7$title = _ref7.title,
      title = _ref7$title === void 0 ? 'Heart' : _ref7$title,
      _ref7$fill = _ref7.fill,
      fill = _ref7$fill === void 0 ? '#000' : _ref7$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 20,
    height: "42",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    stroke: "#FFF",
    strokeWidth: props.clicked ? '1px' : '0',
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,21.85l-1.45-1.32C5.4,15.86,2,12.78,2,9A5.447,5.447,0,0,1,7.39348,3.5q.05326-.00053.10652,0A5.988,5.988,0,0,1,12,5.59,5.988,5.988,0,0,1,16.5,3.5,5.447,5.447,0,0,1,22,8.89348Q22.00053,8.94675,22,9c0,3.78-3.4,6.86-8.55,11.54Z"
  }));
};

exports.Heart = Heart;

var Income = function Income(props, _ref8) {
  var _ref8$title = _ref8.title,
      title = _ref8$title === void 0 ? 'Income Icon' : _ref8$title,
      _ref8$fill = _ref8.fill,
      fill = _ref8$fill === void 0 ? '#000' : _ref8$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: "63",
    height: "62",
    viewBox: "0 0 63 62",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    title: title,
    stroke: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.2779 41.1695C25.3073 40.9186 25.3225 40.6633 25.3225 40.4044C25.3225 36.8617 22.4903 33.9897 18.9965 33.9897C15.5028 33.9897 12.6706 36.8617 12.6706 40.4044C12.6706 42.1292 13.342 43.695 14.4341 44.8478",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "31.6484",
    cy: "27.5751",
    rx: "6.32593",
    ry: "6.41466",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "23.0632",
    cy: "7.41466",
    rx: "6.32593",
    ry: "6.41466",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "51.9817",
    y: "31.2405",
    width: "9.94074",
    height: "26.1168",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.9817 53.6919C49.5719 53.6919 47.9151 53.8446 47.0114 54.1501C41.3598 56.0604 35.4857 58.0459 29.3891 60.1066C27.5817 60.7175 25.9249 60.5648 24.4188 59.6484C22.1595 58.2738 3.18173 47.2772 2.27803 46.8191C1.37433 46.3609 0.470623 44.9863 1.37433 43.1535C2.27803 41.3208 3.63359 41.3208 5.44099 41.779C6.64593 42.0844 12.3694 44.0699 22.6114 47.7354H33.4558C35.8657 47.7783 37.0706 48.8582 37.0706 50.9749",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.9817 37.197C48.9694 37.197 46.4089 37.197 44.3003 37.197C41.1373 37.197 37.9743 38.5716 35.7151 39.488C33.4558 40.4044 32.5521 41.3207 30.2928 41.3207C27.6016 41.3207 25.0411 41.3207 22.6114 41.3207C20.804 41.3207 19.9003 42.3898 19.9003 44.5281C19.9003 46.0554 20.804 47.1245 22.6114 47.7354",
    strokeWidth: "1.5"
  }));
};

exports.Income = Income;

var Schedule = function Schedule(props, _ref9) {
  var _ref9$title = _ref9.title,
      title = _ref9$title === void 0 ? 'Schedule Icon' : _ref9$title,
      _ref9$fill = _ref9.fill,
      fill = _ref9$fill === void 0 ? '#000' : _ref9$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: "61",
    height: "65",
    viewBox: "0 0 61 65",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "24",
    width: "40",
    height: "41"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000450134 24.7383H39.3402V64.0657H0.000450134V24.7383Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9701 64.0663H25.3705C33.0737 64.0663 39.3402 57.8006 39.3402 50.0989V38.7042C39.3402 31.004 33.0737 24.7383 25.3705 24.7383H13.9701C6.26699 24.7383 0.000450134 31.004 0.000450134 38.7042V50.0989C0.000450134 57.8006 6.26699 64.0663 13.9701 64.0663ZM1.51265 38.7043C1.51265 31.837 7.10021 26.25 13.9701 26.25H25.3706C32.2405 26.25 37.828 31.837 37.828 38.7043V50.099C37.828 56.9663 32.2405 62.5548 25.3706 62.5548H13.9701C7.10021 62.5548 1.51265 56.9663 1.51265 50.099V38.7043Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2434 44.4013C17.2434 45.7391 18.3307 46.8274 19.6705 46.8274C21.0103 46.8274 22.0976 45.7391 22.0976 44.4013C22.0976 43.0635 21.0103 41.9751 19.6705 41.9751C18.3307 41.9751 17.2434 43.0635 17.2434 44.4013ZM18.7556 44.4011C18.7556 43.8962 19.1654 43.4866 19.6705 43.4866C20.1756 43.4866 20.5854 43.8962 20.5854 44.4011C20.5854 44.906 20.1756 45.3156 19.6705 45.3156C19.1654 45.3156 18.7556 44.906 18.7556 44.4011Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.0727 55.8691L20.3176 46.1161L21.3867 45.0474L31.1418 54.8004L30.0727 55.8691Z"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9145 42.7321H20.4267V34.6252H18.9145V42.7321Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9145 31.0653H20.4267V27.9226H18.9145V31.0653Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9145 60.8158H20.4267V57.6731H18.9145V60.8158Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.37219 45.1584H6.51605V43.6467H3.37219V45.1584Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.043 45.1584H36.1853V43.6467H33.043V45.1584Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.7818 45.9144H43.0135V44.4027H59.2696V4.7482H20.4258V21.0829H18.9136V3.23657H60.7818V45.9144Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.6691 17.4623H60.0251V15.9507H19.6691V17.4623Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1391 10.9651C47.1391 12.3301 48.2505 13.4396 49.616 13.4396C50.9815 13.4396 52.0945 12.3301 52.0945 10.9651C52.0945 9.60006 50.9815 8.48901 49.616 8.48901C48.2505 8.48901 47.1391 9.60006 47.1391 10.9651ZM48.6512 10.9652C48.6512 10.4331 49.0837 10.0007 49.616 10.0007C50.1498 10.0007 50.5823 10.4331 50.5823 10.9652C50.5823 11.4957 50.1498 11.9281 49.616 11.9281C49.0837 11.9281 48.6512 11.4957 48.6512 10.9652Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.603 10.9651C27.603 12.3301 28.7145 13.4396 30.08 13.4396C31.4455 13.4396 32.557 12.3301 32.557 10.9651C32.557 9.60006 31.4455 8.48901 30.08 8.48901C28.7145 8.48901 27.603 9.60006 27.603 10.9651ZM29.1152 10.9652C29.1152 10.4331 29.5477 10.0007 30.08 10.0007C30.6123 10.0007 31.0448 10.4331 31.0448 10.9652C31.0448 11.4957 30.6123 11.9281 30.08 11.9281C29.5477 11.9281 29.1152 11.4957 29.1152 10.9652Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.8605 9.24498H50.3727V0.0830078H48.8605V9.24498Z"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask11",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "61",
    height: "65"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 64.0657H60.7812V0.0830078H0V64.0657Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask11)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.3245 9.24498H30.8367V0.0830078H29.3245V9.24498Z"
  })));
};

exports.Schedule = Schedule;

var Shield = function Shield(props, _ref10) {
  var _ref10$title = _ref10.title,
      title = _ref10$title === void 0 ? 'Shield Icon' : _ref10$title,
      _ref10$fill = _ref10.fill,
      fill = _ref10$fill === void 0 ? '#000' : _ref10$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: "54",
    height: "65",
    viewBox: "0 0 54 65",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    fill: props.fill || fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.3252 4.31906L31.6463 3.64127L31.6424 3.63945L31.3252 4.31906ZM26.166 1.10864L26.6492 0.535033L26.1664 0.128366L25.6833 0.534617L26.166 1.10864ZM21.0041 4.31906L20.6865 3.63963L20.6832 3.64119L21.0041 4.31906ZM0.999023 6.91952V6.16952H0.249023V6.91952H0.999023ZM7.00385 51.3044L6.48449 51.8455L6.48488 51.8459L7.00385 51.3044ZM26.166 63.7485L25.8198 64.4139L26.166 64.594L26.5123 64.4138L26.166 63.7485ZM45.3227 51.3044L44.8037 50.763L44.8036 50.7631L45.3227 51.3044ZM51.333 6.91952H52.083V6.16952H51.333V6.91952ZM40.7511 46.621L40.2321 46.0796L40.2321 46.0796L40.7511 46.621ZM26.166 56.3203L25.8006 56.9753L26.1662 57.1793L26.5317 56.9751L26.166 56.3203ZM11.5727 46.6182L11.0531 47.1591L11.0537 47.1597L11.5727 46.6182ZM7.5722 13.4384V12.6884H6.8222V13.4384H7.5722ZM23.8322 10.2062L23.5139 9.52711L23.512 9.52801L23.8322 10.2062ZM26.166 9.00537L26.5342 8.35199L26.1674 8.14523L25.7998 8.35084L26.166 9.00537ZM28.5136 10.2144L28.8339 9.53624L28.8321 9.53537L28.5136 10.2144ZM44.7571 13.4384H45.5071V12.6884H44.7571V13.4384ZM43.2058 6.16952C39.2086 6.16952 35.2394 5.34368 31.6463 3.64129L31.004 4.99683C34.8133 6.80167 39.0043 7.66952 43.2058 7.66952V6.16952ZM31.6424 3.63945C29.9045 2.82821 28.1531 1.80184 26.6492 0.535033L25.6828 1.68225C27.3145 3.05676 29.1875 4.14888 31.0079 4.99867L31.6424 3.63945ZM25.6833 0.534617C24.1766 1.8016 22.4222 2.82816 20.6865 3.63964L21.3218 4.99848C23.1389 4.14893 25.0143 3.057 26.6487 1.68267L25.6833 0.534617ZM20.6832 3.64119C17.0872 5.34372 13.1205 6.16952 9.12352 6.16952V7.66952C13.3251 7.66952 17.5132 6.80162 21.3251 4.99693L20.6832 3.64119ZM9.12352 6.16952H0.999023V7.66952H9.12352V6.16952ZM0.249023 6.91952V37.2075H1.74902V6.91952H0.249023ZM0.249023 37.2075C0.249023 42.7152 2.49254 48.0138 6.48449 51.8455L7.52321 50.7633C3.82723 47.2157 1.74902 42.3085 1.74902 37.2075H0.249023ZM6.48488 51.8459C9.3757 54.6166 14.2338 57.7655 18.3179 60.1997C20.3698 61.4227 22.2439 62.4755 23.6049 63.2225C24.2856 63.5961 24.8384 63.8934 25.2214 64.0976C25.4129 64.1997 25.562 64.2785 25.6635 64.3319C25.7142 64.3586 25.7531 64.379 25.7793 64.3927C25.7925 64.3996 25.8025 64.4048 25.8092 64.4083C25.8126 64.4101 25.8152 64.4115 25.817 64.4124C25.8179 64.4128 25.8185 64.4132 25.819 64.4134C25.8193 64.4136 25.8195 64.4137 25.8196 64.4137C25.8197 64.4138 25.8198 64.4139 26.166 63.7485C26.5122 63.0832 26.5122 63.0832 26.5121 63.0832C26.5121 63.0831 26.512 63.0831 26.5118 63.083C26.5114 63.0828 26.5109 63.0825 26.5101 63.0821C26.5086 63.0813 26.5063 63.0801 26.5031 63.0785C26.4969 63.0752 26.4874 63.0703 26.4748 63.0637C26.4496 63.0505 26.4118 63.0307 26.3622 63.0045C26.2629 62.9523 26.1161 62.8747 25.927 62.7739C25.5487 62.5723 25.0014 62.2779 24.3266 61.9075C22.9768 61.1667 21.1188 60.1229 19.0858 58.9112C15.0001 56.476 10.2771 53.4029 7.52281 50.763L6.48488 51.8459ZM26.166 63.7485C26.5123 64.4138 26.5124 64.4138 26.5125 64.4137C26.5126 64.4136 26.5128 64.4135 26.5131 64.4134C26.5135 64.4132 26.5142 64.4128 26.5151 64.4123C26.5169 64.4114 26.5195 64.4101 26.5228 64.4083C26.5296 64.4048 26.5396 64.3996 26.5527 64.3927C26.579 64.3789 26.6178 64.3586 26.6686 64.3319C26.77 64.2785 26.9191 64.1996 27.1106 64.0976C27.4935 63.8934 28.0462 63.5961 28.7267 63.2225C30.0875 62.4754 31.9611 61.4227 34.0125 60.1997C38.0955 57.7655 42.9523 54.6165 45.8418 51.8458L44.8036 50.7631C42.0507 53.4029 37.3291 56.476 33.2444 58.9113C31.212 60.1229 29.3544 61.1667 28.0049 61.9076C27.3303 62.2779 26.783 62.5723 26.4049 62.7739C26.2158 62.8747 26.069 62.9523 25.9698 63.0046C25.9201 63.0307 25.8824 63.0505 25.8572 63.0637C25.8446 63.0703 25.8351 63.0753 25.8288 63.0785C25.8257 63.0802 25.8234 63.0814 25.8219 63.0822C25.8211 63.0826 25.8205 63.0828 25.8202 63.083C25.82 63.0831 25.8199 63.0832 25.8198 63.0832C25.8198 63.0832 25.8198 63.0832 26.166 63.7485ZM45.8417 51.8459C49.8394 48.0141 52.083 42.7153 52.083 37.2075H50.583C50.583 42.3084 48.5049 47.2155 44.8037 50.763L45.8417 51.8459ZM52.083 37.2075V6.91952H50.583V37.2075H52.083ZM51.333 6.16952H43.2058V7.66952H51.333V6.16952ZM44.0071 17.621V37.2075H45.5071V17.621H44.0071ZM44.0071 37.2075C44.0071 40.5442 42.6317 43.7793 40.2321 46.0796L41.2701 47.1624C43.9665 44.5776 45.5071 40.9507 45.5071 37.2075H44.0071ZM40.2321 46.0796C38.5215 47.7194 35.6765 49.6941 32.8473 51.4854C30.0321 53.2679 27.2838 54.837 25.8003 55.6655L26.5317 56.9751C28.0273 56.1398 30.802 54.5558 33.6497 52.7527C36.4835 50.9585 39.4415 48.9154 41.2701 47.1624L40.2321 46.0796ZM26.5315 55.6654C25.0469 54.837 22.2952 53.2658 19.4775 51.482C16.6458 49.6893 13.7995 47.7139 12.0917 46.0768L11.0537 47.1597C12.8796 48.91 15.839 50.9538 18.6751 52.7493C21.5252 54.5537 24.3033 56.1398 25.8006 56.9753L26.5315 55.6654ZM12.0923 46.0774C9.69753 43.7768 8.3222 40.5441 8.3222 37.2075H6.8222C6.8222 40.9508 8.3628 44.5746 11.0531 47.1591L12.0923 46.0774ZM8.3222 37.2075V13.4384H6.8222V37.2075H8.3222ZM7.5722 14.1884H9.12352V12.6884H7.5722V14.1884ZM9.12352 14.1884C14.3781 14.1884 19.573 13.0466 24.1524 10.8844L23.512 9.52801C19.1404 11.592 14.1653 12.6884 9.12352 12.6884V14.1884ZM24.1505 10.8853C24.9701 10.5012 25.7686 10.0871 26.5322 9.65991L25.7998 8.35084C25.0643 8.76233 24.2978 9.1597 23.5139 9.52711L24.1505 10.8853ZM25.7978 9.65875C26.5581 10.0873 27.3655 10.5043 28.1951 10.8934L28.8321 9.53537C28.0362 9.16207 27.2621 8.76217 26.5342 8.35199L25.7978 9.65875ZM28.1932 10.8925C32.7593 13.0494 37.9516 14.1884 43.2058 14.1884V12.6884C38.1636 12.6884 33.1913 11.5945 28.8339 9.53624L28.1932 10.8925ZM43.2058 14.1884H44.7571V12.6884H43.2058V14.1884ZM44.0071 13.4384V17.621H45.5071V13.4384H44.0071Z"
  }));
};

exports.Shield = Shield;

var QuestionMark = function QuestionMark(props, _ref11) {
  var _ref11$title = _ref11.title,
      title = _ref11$title === void 0 ? 'QuestionMark' : _ref11$title,
      _ref11$fill = _ref11.fill,
      fill = _ref11$fill === void 0 ? '#000' : _ref11$fill;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, {
    width: props.width || 12,
    height: "12",
    viewBox: "12 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    title: title
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18,0h0a6,6,0,0,1,6,6h0a6,6,0,0,1-6,6h0a6,6,0,0,1-6-6h0A6,6,0,0,1,18,0Z",
    fill: props.backgroundColor || '#176db6'
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.438,7.204h.716l.088-.716c.982-.173,1.778-.673,1.778-1.786V4.684a1.825,1.825,0,0,0-2.069-1.795,2.694,2.694,0,0,0-2.131.981l.663.707a1.929,1.929,0,0,1,1.441-.7c.637,0,1.017.345,1.017.84v.018c0,.584-.513.946-1.636.99l-.044.044Zm-.256,1.954h1.189V7.947H17.182Z",
    fill: props.textColor || '#FFF'
  }));
};

exports.QuestionMark = QuestionMark;

var TargetedMarket = function TargetedMarket(props, _ref12) {
  var _ref12$title = _ref12.title,
      title = _ref12$title === void 0 ? 'TargetedMarket' : _ref12$title;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    version: "1.1",
    title: title,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: ".5"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-10",
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 14.467879)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.243944,8.67393413 L61.290504,8.67393413 L61.290504,45.2675463 L8.007384,45.2675463 C4.773384,45.2675463 2.138664,42.6450655 2.130744,39.4090928 L2.130744,8.73186042 C2.130744,5.49852067 4.768104,2.87077388 8.007384,2.87077388 L12.257784,2.87077388 L12.257784,35.3832162 L8.007384,35.3832162 C5.942904,35.3832162 4.263864,37.0578123 4.263864,39.1168284 L4.263864,39.4090928 C4.263864,41.4681088 5.942904,43.142705 8.007384,43.142705 L8.007384,41.0152306 C7.117704,41.0152306 6.394344,40.2937851 6.394344,39.4090928 L6.394344,39.1168284 C6.394344,38.2321361 7.117704,37.5106905 8.007384,37.5106905 L14.388264,37.5106905 L14.388264,0.745932532 L8.007384,0.745932532 C3.590664,0.745932532 0.000264,4.32682997 0.000264,8.73186042 L0.000264,36.4469534 L0.000264,39.4222579 C0.008184,43.8193893 3.601224,47.3950207 8.007384,47.3950207 L63.420984,47.3950207 L63.420984,6.54909279 L58.790424,6.54909279 C58.647864,7.26527228 58.468344,7.97618574 58.243944,8.67393413",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.455088,21.0156551 L15.455088,23.1404965 L21.165408,23.1404965 C20.943648,22.4427481 20.761488,21.7344676 20.618928,21.0156551 L15.455088,21.0156551 Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.70428,0 C39.09708,0 38.47932,0.0315961538 37.86684,0.0947884615 C29.18388,0.992645833 22.3806,8.54149359 22.38324,17.2804631 C22.38324,19.9924663 23.00364,22.599149 24.22596,25.0241538 C26.19276,28.9736731 34.22364,40.3851506 38.83572,46.8360321 L39.70428,48.049851 L40.57284,46.8360321 C45.18756,40.3825176 53.22372,28.963141 55.18788,25.0136218 C56.40756,22.593883 57.02532,19.9898333 57.02532,17.2751971 C57.02532,7.74895673 49.2558,0 39.70428,0 M53.2818,24.0657372 C51.44964,27.7440561 43.74876,38.7079215 39.70428,44.3873301 C35.66244,38.7131875 27.9642,27.7545881 26.13204,24.0736362 C25.0602,21.9435288 24.51636,19.6580737 24.51636,17.2778301 C24.51372,9.61576282 30.47484,2.99636859 38.0886,2.20909776 C38.62716,2.15380449 39.171,2.12484135 39.70428,2.12484135 C48.081,2.12484135 54.89484,8.92064744 54.89484,17.2751971 C54.89484,19.6554407 54.351,21.9382628 53.2818,24.0657372"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.065728,6.79475288 C37.602048,6.35767276 34.138368,7.6610141 31.849488,10.2545317 C29.861568,12.5057577 28.940208,15.5126583 29.323008,18.5063939 C29.911728,23.1325974 33.708048,26.9162369 38.346528,27.5033987 C38.797968,27.561325 39.254688,27.5902881 39.703488,27.5902881 C42.705168,27.5902881 45.569568,26.2974788 47.560128,24.0436199 C49.548048,21.7950269 50.466768,18.7881263 50.086608,15.7943907 C49.497888,11.1681872 45.704208,7.38454776 41.065728,6.79475288 M45.960288,22.640224 C44.133408,24.7045061 41.377248,25.7471792 38.613168,25.3943554 C34.925088,24.9283122 31.907568,21.9187785 31.437648,18.2378266 C31.128768,15.8154548 31.841568,13.4773394 33.449328,11.6605606 C35.033328,9.86484583 37.314288,8.83533782 39.703488,8.83533782 C40.065168,8.83533782 40.432128,8.85903494 40.796448,8.90379615 C44.484528,9.37247244 47.502048,12.3820061 47.971968,16.062958 C48.280848,18.4853298 47.565408,20.8208122 45.960288,22.640224"
  }))));
};

exports.TargetedMarket = TargetedMarket;

var Growth = function Growth(props, _ref13) {
  var _ref13$title = _ref13.title,
      title = _ref13$title === void 0 ? 'Growth' : _ref13$title;
  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    version: "1.1",
    title: title,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("g", {
    stroke: props.fill || '#202020',
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    stroke: props.fill || '#202020',
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Regular"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26,18.8 L45.8,0.8",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    id: "Shape",
    points: "35 0.8 45.8 0.8 45.8 11.6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.8,8 L54.8,54.8",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.8,20.6 L45.8,54.8",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.8,33.2 L36.8,54.8",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.8,54.8 L26,54.8",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.4,35 L26,35 L26,53.6 C26,54.2627417 25.4627417,54.8 24.8,54.8 L14.6,54.8 C13.9372583,54.8 13.4,54.2627417 13.4,53.6 L13.4,35 Z",
    id: "Shape",
    transform: "translate(19.700000, 44.900000) rotate(-180.000000) translate(-19.700000, -44.900000) "
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.4,54.8 L0.8,54.8 L0.8,26 C0.8,25.0058875 1.60588745,24.2 2.6,24.2 L17,24.2 C17.9941125,24.2 18.8,25.0058875 18.8,26 L18.8,35",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.2,35 L0.8,35",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.2,42.2 L0.8,42.2",
    id: "Shape"
  })))));
};

exports.Growth = Growth;

var FacebookIcon = function FacebookIcon(_ref14) {
  var _ref14$fill = _ref14.fill,
      fill = _ref14$fill === void 0 ? '#666' : _ref14$fill,
      _ref14$title = _ref14.title,
      title = _ref14$title === void 0 ? 'Fuel Pump Icon' : _ref14$title,
      props = _objectWithoutProperties(_ref14, _excluded);

  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "91.882 1914 14.118 14.174",
    style: {
      enableBackground: 'new 0 0 19.74 24.56'
    },
    xmlSpace: "preserve",
    fill: fill,
    ariaLabeledBy: "title"
  }, props), /*#__PURE__*/_react.default.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M104.734,1914H93.147c-0.43,0-1.265,0.838-1.265,1.271v11.631c0,0.432,0.835,1.271,1.265,1.271h6.034v-5.381                                    h-1.945v-1.945h1.945v-1.495c0-1.832,1.38-2.918,3.007-2.918c0.779,0,1.189,0.084,1.385,0.11v1.854h-1.38                                    c-0.885,0-1.05,0.439-1.05,1.06v1.391h2.456l-0.32,1.945h-2.136v5.381h3.591c0.431,0,1.266-0.839,1.266-1.271v-11.631                                    C106,1914.838,105.165,1914,104.734,1914z"
  }));
};

exports.FacebookIcon = FacebookIcon;

var TwitterIcon = function TwitterIcon(_ref15) {
  var _ref15$fill = _ref15.fill,
      fill = _ref15$fill === void 0 ? '#666' : _ref15$fill,
      _ref15$title = _ref15.title,
      title = _ref15$title === void 0 ? 'Fuel Pump Icon' : _ref15$title,
      props = _objectWithoutProperties(_ref15, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "50 68.734 200 162.536",
    style: {
      enableBackground: 'new 0 0 19.74 24.56'
    },
    xmlSpace: "preserve",
    fill: fill,
    ariaLabeledBy: "title"
  }, props), /*#__PURE__*/_react.default.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M250,87.974c-7.357,3.264-15.268,5.469-23.566,6.461c8.471-5.078,14.979-13.119,18.041-22.701                                c-7.929,4.703-16.709,8.117-26.057,9.957c-7.484-7.975-18.148-12.957-29.95-12.957c-22.659,0-41.033,18.371-41.033,41.031                                c0,3.216,0.363,6.348,1.062,9.351c-34.102-1.711-64.336-18.047-84.574-42.872c-3.532,6.06-5.556,13.108-5.556,20.628                                c0,14.236,7.244,26.795,18.254,34.153c-6.726-0.213-13.053-2.059-18.585-5.132c-0.004,0.171-0.004,0.343-0.004,0.516                                c0,19.88,14.144,36.464,32.915,40.233c-3.443,0.938-7.068,1.439-10.81,1.439c-2.644,0-5.214-0.258-7.72-0.736                                c5.222,16.301,20.375,28.165,38.331,28.495c-14.043,11.007-31.735,17.565-50.96,17.565c-3.312,0-6.578-0.194-9.788-0.574                                c18.159,11.643,39.727,18.438,62.899,18.438c75.473,0,116.746-62.524,116.746-116.748c0-1.779-0.039-3.548-0.119-5.309                                C237.543,103.429,244.499,96.202,250,87.974z"
  }));
};

exports.TwitterIcon = TwitterIcon;

var YoutubeIcon = function YoutubeIcon(_ref16) {
  var _ref16$fill = _ref16.fill,
      fill = _ref16$fill === void 0 ? '#666' : _ref16$fill,
      _ref16$fillBackground = _ref16.fillBackground,
      fillBackground = _ref16$fillBackground === void 0 ? '#000' : _ref16$fillBackground,
      _ref16$title = _ref16.title,
      title = _ref16$title === void 0 ? 'Fuel Pump Icon' : _ref16$title,
      props = _objectWithoutProperties(_ref16, _excluded3);

  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "153 1915 16 12",
    style: {
      enableBackground: 'new 0 0 19.74 24.56'
    },
    xmlSpace: "preserve",
    fill: fill,
    ariaLabeledBy: "title"
  }, props), /*#__PURE__*/_react.default.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M156.2,1915h9.6c1.769,0,3.2,1.535,3.2,3.429v5.144c0,1.894-1.434,3.428-3.2,3.428h-9.6                                c-1.768,0-3.2-1.535-3.2-3.428v-5.144C153,1916.535,154.433,1915,156.2,1915z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: fillBackground,
    d: "M159,1917v8l6-4L159,1917z"
  }));
};

exports.YoutubeIcon = YoutubeIcon;

var InstagramIcon = function InstagramIcon(_ref17) {
  var _ref17$fill = _ref17.fill,
      fill = _ref17$fill === void 0 ? '#666' : _ref17$fill,
      _ref17$title = _ref17.title,
      title = _ref17$title === void 0 ? 'Fuel Pump Icon' : _ref17$title,
      props = _objectWithoutProperties(_ref17, _excluded4);

  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.74 24.56",
    style: {
      enableBackground: 'new 0 0 19.74 24.56'
    },
    xmlSpace: "preserve",
    fill: fill,
    ariaLabeledBy: "title"
  }, props), /*#__PURE__*/_react.default.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M10,1.8c2.7,0,3,0,4,0.1c1,0,1.5,0.2,1.9,0.3C16.4,2.4,16.7,2.6,17,3c0.3,0.3,0.6,0.7,0.7,1.1                                C17.9,4.5,18.1,5,18.1,6c0,1.1,0.1,1.4,0.1,4s0,3-0.1,4c0,1-0.2,1.5-0.3,1.9c-0.2,0.5-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7                                c-0.4,0.1-0.9,0.3-1.9,0.3c-1.1,0-1.4,0.1-4,0.1s-3,0-4-0.1c-1,0-1.5-0.2-1.9-0.3C3.6,17.6,3.3,17.4,3,17c-0.3-0.3-0.6-0.7-0.7-1.1                                C2.1,15.5,1.9,15,1.9,14c0-1.1-0.1-1.4-0.1-4s0-3,0.1-4c0-1,0.2-1.5,0.3-1.9C2.4,3.6,2.6,3.3,3,3c0.3-0.3,0.7-0.6,1.1-0.7                                C4.5,2.1,5,1.9,6,1.9C7,1.8,7.3,1.8,10,1.8 M10,0C7.3,0,6.9,0,5.9,0.1c-1.1,0-1.8,0.2-2.4,0.5C2.8,0.8,2.2,1.1,1.7,1.7                                C1.1,2.2,0.8,2.8,0.5,3.4C0.3,4.1,0.1,4.8,0.1,5.9C0,6.9,0,7.3,0,10c0,2.7,0,3.1,0.1,4.1c0,1.1,0.2,1.8,0.5,2.4                                c0.3,0.7,0.6,1.2,1.2,1.8c0.6,0.6,1.1,0.9,1.8,1.2c0.6,0.2,1.4,0.4,2.4,0.5C6.9,20,7.3,20,10,20s3.1,0,4.1-0.1                                c1.1,0,1.8-0.2,2.4-0.5c0.7-0.3,1.2-0.6,1.8-1.2c0.6-0.6,0.9-1.1,1.2-1.8c0.2-0.6,0.4-1.4,0.5-2.4c0-1.1,0.1-1.4,0.1-4.1                                s0-3.1-0.1-4.1c0-1.1-0.2-1.8-0.5-2.4c-0.3-0.7-0.6-1.2-1.2-1.8c-0.6-0.6-1.1-0.9-1.8-1.2c-0.6-0.2-1.4-0.4-2.4-0.5                                C13.1,0,12.7,0,10,0L10,0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M10,4.9c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1S12.8,4.9,10,4.9z M10,13.3                                c-1.8,0-3.3-1.5-3.3-3.3S8.2,6.7,10,6.7s3.3,1.5,3.3,3.3S11.8,13.3,10,13.3z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    fill: fill,
    cx: "15.3",
    cy: "4.7",
    r: "1.2"
  }));
};

exports.InstagramIcon = InstagramIcon;

var PinterestIcon = function PinterestIcon(_ref18) {
  var _ref18$fill = _ref18.fill,
      fill = _ref18$fill === void 0 ? '#666' : _ref18$fill,
      _ref18$title = _ref18.title,
      title = _ref18$title === void 0 ? 'Fuel Pump Icon' : _ref18$title,
      props = _objectWithoutProperties(_ref18, _excluded5);

  return /*#__PURE__*/_react.default.createElement(_index.default.SVG, _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.74 24.56",
    style: {
      enableBackground: 'new 0 0 19.74 24.56'
    },
    xmlSpace: "preserve",
    fill: fill,
    ariaLabeledBy: "title"
  }, props), /*#__PURE__*/_react.default.createElement("title", {
    id: "title"
  }, title), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: "M10,0C4.6,0,0.2,4.4,0.2,9.8c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8C19.8,4.4,15.4,0,10,0z M10,18.9                            c-0.9,0-1.8-0.1-2.7-0.4c0.4-0.6,0.9-1.6,1.1-2.4C8.5,15.7,9,14,9,14c0.3,0.6,1.2,1,2.1,1c2.7,0,4.7-2.5,4.7-5.7                            c0-3-2.5-5.3-5.6-5.3c-3.9,0-6,2.6-6,5.5c0,1.3,0.7,3,1.8,3.5c0.2,0.1,0.3,0,0.3-0.1c0-0.1,0.2-0.7,0.3-1c0-0.1,0-0.2-0.1-0.3                            c-0.4-0.5-0.7-1.3-0.7-2.1c0-2,1.5-3.9,4.1-3.9c2.2,0,3.8,1.5,3.8,3.7c0,2.5-1.2,4.2-2.9,4.2c-0.9,0-1.6-0.7-1.3-1.6                            c0.3-1.1,0.8-2.2,0.8-3c0-0.7-0.4-1.3-1.2-1.3c-0.9,0-1.6,0.9-1.6,2.2c0,0.8,0.3,1.3,0.3,1.3S6.9,15,6.7,15.7                            c-0.2,0.8-0.1,1.9,0,2.6C3.3,17,0.9,13.7,0.9,9.8c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1C19.1,14.9,15,18.9,10,18.9z"
  }));
};

exports.PinterestIcon = PinterestIcon;